// extracted by mini-css-extract-plugin
export default {"container":"LocationBlock_container__WzrT2","title":"LocationBlock_title__7lFxZ","inputs_container":"LocationBlock_inputs_container__vp63e"};